<template>
    <span v-if="estimate.status === 'secured'">
        <i class="fa fa-check text-green-500 mr-1"></i>
        <span class="text-green-600">Secured</span>
    </span>
    <span v-else-if="estimate.status === 'declined'">
        <i class="fa fa-check text-red-500 mr-1"></i>
        <span class="text-red-600">Declined</span>
    </span>
    <span v-else-if="estimate.viewed_by_remote_recipient">
        <i class="far fa-eye text-blue-500 mr-1"></i>
        <span class="text-blue-600">Sent &amp; Viewed</span>
    </span>
    <span v-else-if="estimate.status === 'sent'">
        <i class="fa fa-paper-plane text-blue-500 mr-1"></i>
        <span class="text-blue-600">Sent</span>
    </span>
    <span v-else>
        <i class="fa fa-pencil-alt text-gray-400 mr-1"></i>
        <span class="text-gray-500">Draft</span>
    </span>
</template>

<script>
export default {
    props: {
        estimate: Object,
    },
}
</script>
